import gButtonColor from "glesys-controlpanel/helpers/g-button-color";
import mergeClasses from "glesys-controlpanel/modifiers/merge-classes";
import Content from "./content";
import IconsExternalLink from "../icons/external-link";

const isCompact = (display) => display === "compact";

const color = (color) => color || "outline";

<template>
  <a
    class="flex items-center relative rounded text-sm
      {{if (isCompact @display) 'px-2 py-1' 'px-4 py-2'}}
      {{if @disabled 'cursor-not-allowed pointer-events-none opacity-60' 'cursor-pointer'}}
      {{gButtonColor (color @color)}}
      transition-all duration-200"
    href="#"
    target="{{if @external '_blank'}}"
    rel="{{if @external 'noopener noreferrer'}}"
    {{mergeClasses}}
    ...attributes
  >
    <Content @loading={{@loading}} @color={{color @color}}>
      <div class="flex items-center">
        {{yield}}
        {{#if @external}}
          <IconsExternalLink class="w-4 ml-2" />
        {{/if}}
      </div>
    </Content>
  </a>
</template>
